export default __webpack_public_path__ + "static/media/information.256a3ba5.svg";